import classNames from 'classnames'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { useEffect, useState } from 'react'

import styles from './Preview.module.scss'

interface IProps {
  src: string | File
  onDelete: () => void
  formIsFinalized: boolean
  className?: string
}

export const Preview = ({ src, onDelete, formIsFinalized, className }: IProps) => {
  const [dimensions, setDimensions] = useState({ height: 0, width: 0 })
  const [previewSrc, setPreviewSrc] = useState<string>('')

  useEffect(() => {
    if (src instanceof File) {
      const objectUrl = URL.createObjectURL(src)
      setPreviewSrc(objectUrl)

      return () => {
        URL.revokeObjectURL(objectUrl)
      }
    } else {
      setPreviewSrc(src)
    }

    return undefined
  }, [src])

  const onImgLoad = ({ target: img }: any) => {
    setDimensions({
      height: img.naturalHeight,
      width: img.naturalWidth,
    })
  }

  const isSquareImg = dimensions.height >= dimensions.width

  return (
    <div className={styles.root}>
      <img
        className={classNames(styles.img, { [styles.img_square]: isSquareImg }, className)}
        src={previewSrc}
        onLoad={onImgLoad}
        alt="preview"
      />

      <RenderWhen condition={!formIsFinalized}>
        <i className={classNames(styles.icon, 'kbase kbase-close')} onClick={onDelete} />
      </RenderWhen>
    </div>
  )
}
